import React, { useEffect, useState, useRef } from 'react';
import Callable from '../../shared/Callable';


export default function EmployerIdThankyouPopup(props) {
    const node = useRef();


    return (
        <div className="employerid-popup thankyou-popup show" aria-live='polite' role='alert' aria-modal='true' ref={node}>
            <div className='employer-id-popup'>
            <div className="employer-id-container">
                    <div className='content thankyou'>
                        <div className='header'>Thank You!</div>
                        <div className='subtext'>Your Employee ID was submitted. We will be in touch if we require additional information to complete the process. If you have any questions, please call <Callable className="greentext" phone="800 VAN-4-WORK" /></div>
                    </div>

                    <div className='button-container tankyou'>
                        <button tabIndex={0} className='continue-button thankyou' onClick={() => props.closeThankyou()} >Close</button>
                    </div>

                </div>
            </div>
        </div>
    );
}
